module.exports = __webpack_public_path__ + "static/media/17.767db0ae.jpg";